var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer has-background-ghost-white"},[_c('div',{staticClass:"content has-text-centered"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/logo-footer.png")}}),_c('p',{staticClass:"is-size-7 has-text-grey"},[_vm._v("HIRATI: Ateneo Law School Career Fair 2023")])])])
}]

export { render, staticRenderFns }